import storejs from 'storejs';
import { noop } from 'lodash';

// local depenedcies
import { getStore } from 'store';
import { IS_USER_LOGGED_IN } from 'constants/common';
import { REDUCER } from 'constants/entity-names';
import { userLoggedIn } from 'store/actions/userLoggedIn';
import { clearUserSession } from 'store/actions/clearUserSession';

// get a global redux store ( creates empty store if not already created )
const store = getStore();

/**
 * @desc check if user is logged in
 * @example
 * import { isUserLoggedIn } from 'utils/sessionManager';
*/
export const isUserLoggedIn = () => {
   if( 'development' === CONFIG.env ) {
		return true;
   } else {
		return store.getState()[ REDUCER.USER_SESSION ].isUserLoggedIn;
   }
};

/**
* @desc set user logged in inside session
 * @example
 * import { setUserLoggedIn } from 'utils/sessionManager';
*/
export const setUserLoggedIn = () => {
   if( 'development' === CONFIG.env ) {
		storejs.set( IS_USER_LOGGED_IN, true );
   } else {
		store.dispatch( userLoggedIn() );
   }
};

/**
* @desc remove local storage data
 * @example
 * import { clearLocalstorage } from 'utils/sessionManager';
*/
export const clearLocalstorage = ( options = {} ) => {
   if( options.onlyUserParams ) {
		storejs.remove( IS_USER_LOGGED_IN );
   } else {
		storejs.clearAll();
   }
};

/**
* @desc clear user specific session data
 * @example
 * import { clearUserSessionData } from 'utils/sessionManager';
*/
export const clearUserSessionData = ( done = noop ) => {

   // clear session storage
   clearLocalstorage( { onlyUserParams: true } );

   // clear redux store
   store.dispatch( clearUserSession() );

   // execute done function
   done();
};
